import { render, staticRenderFns } from "./PersonalRegister.vue?vue&type=template&id=fe04b5e4&scoped=true&"
import script from "./PersonalRegister.vue?vue&type=script&lang=js&"
export * from "./PersonalRegister.vue?vue&type=script&lang=js&"
import style0 from "./PersonalRegister.vue?vue&type=style&index=0&id=fe04b5e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe04b5e4",
  null
  
)

export default component.exports